import { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Buton } from "@koclukpanel/ui";
import { ApiHatasi, benGetir, sudoDurum } from "./api";
import { izinVarMi } from "./izin";
import { SudoKapisi } from "./SudoKapisi";

/** F-SYS-04 — dosyayı tarayıcı indirir; sudo kapısı mevcut oturum istemcisinden açılır. */
export function DenemeDisaAktar({ denemeId }: { denemeId: string }) {
  const [kapiAcik, setKapiAcik] = useState(false);
  const ben = useQuery({ queryKey: ["ben"], queryFn: benGetir, retry: false });
  const indirmeyiBaslat = () => {
    const baglanti = document.createElement("a");
    baglanti.href = `/api/v1/deneme/${encodeURIComponent(denemeId)}/sonuclar/disaaktar`;
    baglanti.download = "deneme-sonuclari.csv";
    document.body.appendChild(baglanti);
    baglanti.click();
    baglanti.remove();
  };
  const indir = useMutation({
    mutationFn: sudoDurum,
    onSuccess: (durum) => {
      if (durum.acik) indirmeyiBaslat();
      else setKapiAcik(true);
    },
  });
  if (!ben.data || !izinVarMi(ben.data.izinler, "deneme.sonuc.disaaktar")) return null;
  return (
    <div className="flex flex-col gap-2">
      <Buton gorunum="ikincil" disabled={indir.isPending} onClick={() => indir.mutate()}>
        Dışa aktar (CSV)
      </Buton>
      {indir.isError && (
        <p role="alert" className="text-hata-700 text-sm">
          {indir.error instanceof ApiHatasi ? indir.error.message : "İndirme başlatılamadı."}
        </p>
      )}
      {kapiAcik && (
        <SudoKapisi
          aciklama="Deneme sonuçlarını dışa aktarmak için şifrenizi doğrulayın."
          onVazgec={() => setKapiAcik(false)}
          acildi={() => {
            setKapiAcik(false);
            indirmeyiBaslat();
          }}
        />
      )}
    </div>
  );
}
